import axios from 'axios';
import { DELETE_VENDOR } from '../../constants';

export const deleteVendor = (id, closeDialog, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadDeleteVendor());
  axios
    .delete(`/admin/deleteVendor/${id}`, config)
    .then((res) => {
      dispatch(setDeleteVendor(res));
      closeDialog();
    })
    .catch((err) => {
      dispatch(errorDeleteVendor(err.response));
      onError(err.response);
    });
};

export const loadDeleteVendor = () => ({
  type: DELETE_VENDOR.LOAD,
});

export const setDeleteVendor = (data) => ({
  type: DELETE_VENDOR.SUCCESS,
  payload: data,
});

export const errorDeleteVendor = (error) => ({
  type: DELETE_VENDOR.FAIL,
  payload: error,
});
